export type MediaType = "Photo" | "Video";

export const MediaTypes =
{
    Photo: {
        Extensions: ['jpg', 'jpeg'],
        MimeTypes: ['image/jpeg']
    },

    Video:{
        Extensions: ['mov', 'avi', 'mpg', 'mp4', 'mts'],
        MimeTypes: ['video/mov', 'video/avi', 'video/mpg', 'video/mp4', 'video/mts']
    }
}


const prefixExtensionsWithPeriod = (extensions: string[]) => extensions.map(ext => '.' + ext);

//
// Builds a File Inputs accept attribute value from our accepted media types. Due
// to the behavior of some browsers (mobile, etc) we currently use file extensions
// for photos and mime types for videos. When using purely extensions or mimetypes
// certian phone/browser combinations would fail to show live video capture as an option.
// Another breakout occured in 12/2022 - frozen phones, happens on multiple file uploaders.
//
// References
//      https://app.asana.com/0/24608526417701/1202205638471803/f
//
export function buildFileInputAcceptValue(includePhoto: boolean, includeVideo: boolean):string
{
    let accept: string[] = [];

    if (includePhoto) {
        accept = accept.concat(prefixExtensionsWithPeriod(MediaTypes.Photo.Extensions));
    }

    if (includeVideo) {
        accept = accept.concat(prefixExtensionsWithPeriod(MediaTypes.Video.Extensions));        
    }

    // Dont ask.. Chrome 100 doesn't work without this? Nutty
    accept = accept.concat(".dealervision");

    return accept.join(", ");
}

export function buildAcceptedExtensionList(includePhoto: boolean, includeVideo: boolean):string[] {
    let accept: string[] = [];

    if (includePhoto) {
        accept = accept.concat(prefixExtensionsWithPeriod(MediaTypes.Photo.Extensions));
    }

    if (includeVideo) {
        accept = accept.concat(prefixExtensionsWithPeriod(MediaTypes.Video.Extensions));
    }

    return accept;
}

export function getFileExtension(filename:string){
    const fileNameParts = filename.split(".");

    if (fileNameParts.length === 1 || (fileNameParts[0] === "" && fileNameParts.length === 2)) {
        return undefined;
    }

    return fileNameParts.pop()?.toLowerCase();
}



export function getSupportedMediaType(extension: string, includePhoto: boolean, includeVideo: boolean): MediaType|undefined{

    if (includePhoto && MediaTypes.Photo.Extensions.indexOf(extension) > -1){
        return "Photo";
    }

    if (includeVideo && MediaTypes.Video.Extensions.indexOf(extension) > -1) {
        return "Video";
    }

    return undefined;
}